/**
* @module SDKModule
* @author Jonathan Casarrubias <t:@johncasarrubias> <gh:jonathan-casarrubias>
* @license MIT 2016 Jonathan Casarrubias
* @version 2.1.0
* @description
* The SDKModule is a generated Software Development Kit automatically built by
* the LoopBack SDK Builder open source module.
*
* The SDKModule provides Angular 2 >= RC.5 support, which means that NgModules
* can import this Software Development Kit as follows:
*
*
* APP Route Module Context
* ============================================================================
* import { NgModule }       from '@angular/core';
* import { BrowserModule }  from '@angular/platform-browser';
* // App Root 
* import { AppComponent }   from './app.component';
* // Feature Modules
* import { SDK[Browser|Node|Native]Module } from './shared/sdk/sdk.module';
* // Import Routing
* import { routing }        from './app.routing';
* @NgModule({
*  imports: [
*    BrowserModule,
*    routing,
*    SDK[Browser|Node|Native]Module.forRoot()
*  ],
*  declarations: [ AppComponent ],
*  bootstrap:    [ AppComponent ]
* })
* export class AppModule { }
*
**/
import { JSONSearchParams } from './services/core/search.params';
import { ErrorHandler } from './services/core/error.service';
import { LoopBackAuth } from './services/core/auth.service';
import { LoggerService } from './services/custom/logger.service';
import { SDKModels } from './services/custom/SDKModels';
import { InternalStorage, SDKStorage } from './storage/storage.swaps';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CookieBrowser } from './storage/cookie.browser';
import { StorageBrowser } from './storage/storage.browser';
import { SocketBrowser } from './sockets/socket.browser';
import { SocketDriver } from './sockets/socket.driver';
import { SocketConnection } from './sockets/socket.connections';
import { RealTime } from './services/core/real.time';
import { AccountApi } from './services/custom/Account';
import { AppApi } from './services/custom/App';
import { PaastenantApi } from './services/custom/Paastenant';
import { ApptypeApi } from './services/custom/Apptype';
import { TenantApi } from './services/custom/Tenant';
import { CounterApi } from './services/custom/Counter';
import { CurrencyApi } from './services/custom/Currency';
import { MetadataApi } from './services/custom/Metadata';
import { MetadatahistoryApi } from './services/custom/Metadatahistory';
import { MetafieldApi } from './services/custom/Metafield';
import { EntityApi } from './services/custom/Entity';
import { MenuitemApi } from './services/custom/Menuitem';
import { PicklistApi } from './services/custom/Picklist';
import { PicktableApi } from './services/custom/Picktable';
import { ChartApi } from './services/custom/Chart';
import { FormtemplateApi } from './services/custom/Formtemplate';
import { ContactApi } from './services/custom/Contact';
import { EntityfieldApi } from './services/custom/Entityfield';
import { EntityformulaApi } from './services/custom/Entityformula';
import { EntitypagelayoutApi } from './services/custom/Entitypagelayout';
import { EntitylistlayoutApi } from './services/custom/Entitylistlayout';
import { EntitycompactlayoutApi } from './services/custom/Entitycompactlayout';
import { EntityrecordApi } from './services/custom/Entityrecord';
import { EntityrecordhistoryApi } from './services/custom/Entityrecordhistory';
import { TimeseriesApi } from './services/custom/Timeseries';
import { InstallationApi } from './services/custom/Installation';
import { NotificationApi } from './services/custom/Notification';
import { ProfileApi } from './services/custom/Profile';
import { EntitysearchlayoutApi } from './services/custom/Entitysearchlayout';
import { DataelementApi } from './services/custom/Dataelement';
import { DashboardApi } from './services/custom/Dashboard';
import { ActivityApi } from './services/custom/Activity';
import { CountryApi } from './services/custom/Country';
import { TimezoneApi } from './services/custom/Timezone';
import { ReporttemplateApi } from './services/custom/Reporttemplate';
import { ReportdownloadApi } from './services/custom/Reportdownload';
import { AggregatesApi } from './services/custom/Aggregates';
import { NoteApi } from './services/custom/Note';
import { ContainerApi } from './services/custom/Container';
/**
* @module SDKBrowserModule
* @description
* This module should be imported when building a Web Application in the following scenarios:
*
*  1.- Regular web application
*  2.- Angular universal application (Browser Portion)
*  3.- Progressive applications (Angular Mobile, Ionic, WebViews, etc)
**/
@NgModule({
  imports:      [ CommonModule, HttpModule ],
  declarations: [ ],
  exports:      [ ],
  providers:    [
    ErrorHandler,
    SocketConnection
  ]
})
export class SDKBrowserModule {
  static forRoot(internalStorageProvider: any = {
    provide: InternalStorage,
    useClass: CookieBrowser
  }): ModuleWithProviders {
    return {
      ngModule  : SDKBrowserModule,
      providers : [
        LoopBackAuth,
        LoggerService,
        JSONSearchParams,
        SDKModels,
        RealTime,
        AccountApi,
        AppApi,
        PaastenantApi,
        ApptypeApi,
        TenantApi,
        CounterApi,
        CurrencyApi,
        MetadataApi,
        MetadatahistoryApi,
        MetafieldApi,
        EntityApi,
        MenuitemApi,
        PicklistApi,
        PicktableApi,
        ChartApi,
        FormtemplateApi,
        ContactApi,
        EntityfieldApi,
        EntityformulaApi,
        EntitypagelayoutApi,
        EntitylistlayoutApi,
        EntitycompactlayoutApi,
        EntityrecordApi,
        EntityrecordhistoryApi,
        TimeseriesApi,
        InstallationApi,
        NotificationApi,
        ProfileApi,
        EntitysearchlayoutApi,
        DataelementApi,
        DashboardApi,
        ActivityApi,
        CountryApi,
        TimezoneApi,
        ReporttemplateApi,
        ReportdownloadApi,
        AggregatesApi,
        NoteApi,
        ContainerApi,
        internalStorageProvider,
        { provide: SDKStorage, useClass: StorageBrowser },
        { provide: SocketDriver, useClass: SocketBrowser }
      ]
    };
  }
}
/**
* Have Fun!!!
* - Jon
**/
export * from './models/index';
export * from './services/index';
export * from './lb.config';
export * from './storage/storage.swaps';
export { CookieBrowser } from './storage/cookie.browser';
export { StorageBrowser } from './storage/storage.browser';



// WEBPACK FOOTER //
// ./src/app/shared/sdk/index.ts